<template>
  <div >
    <div class="outer-body">
      <!-- 学历自考 -->
      <div v-if="isXueli" class="middle-main">
        <img class="back-img" :src="`${assetsUrl}imgs/course/teacherCourse/xuelizikao.jpg`" />
        <div class="teacher-m btn-panel" style="top:220px">
          <a v-for="(item,index) of list" :key="index" :href="item.url" target="_blank">
            <button class="able-in" style="background-color: white;">
              {{ item.name }}
            </button>
          </a>
        </div>
      </div>
      <div v-if="!isXueli" class="middle-main">
        <img class="back-img" v-if="data.courseType === '11'" :src="`${assetsUrl}imgs/course/middle/middleBack.jpg`" />
        <img class="back-img" v-if="data.courseType === '18'" :src="`${assetsUrl}imgs/course/middle/swsBack.jpg`" />
        <div
          v-if="data.courseType === '18'"
          style="position:absolute; flex-wrap: wrap;top:44vh;"
          class="teacher-m"
          id="middle"
        >
          <a
            v-for="item of list"
            :key="item.id"
            :style="{ margin: '10px', width: list.length > 15 ? '10%' : '15%' }"
            @click="isIn(item)"
            :href="item.url"
            target="_blank"
          >
            <button class="able-in" style="background-color: white;">
              {{ item.name }}
            </button>
          </a>
        </div>
        <div
          v-if="data.courseType === '11'"
          style="position:absolute; flex-wrap: wrap;top:44vh;"
          class="teacher-m"
          id="middle"
        >
          <a
            v-for="item of list"
            :key="item.id"
            :style="{
              margin: list.length > 15 ? '.1rem .1rem' : '.1rem 1rem',
              width: list.length > 15 ? '10%' : '15%'
            }"
            @click="isIn(item)"
            :href="item.url"
            target="_blank"
          >
            <button class="able-in" style="background-color: white;">
              <i class="iconfont icon-mima disable-icon" aria-hidden="true" ></i>{{ item.name }}
            </button>
          </a>
        </div>
        <img class="back-img" v-if="data.courseType === '121'" :src="`${assetsUrl}imgs/course/teacherCourse/cjBacky.jpg`" />
        <img class="back-img" v-if="data.courseType === '122'" :src="`${assetsUrl}imgs/course/teacherCourse/cjBackx.jpg`" />
        <img class="back-img" v-if="data.courseType === '123'" :src="`${assetsUrl}imgs/course/teacherCourse/cjBackz.jpg`" />
        <img class="back-img" v-if="data.courseType === '1611' || data.courseType === '1612'" :src="`${assetsUrl}imgs/course/teacherCourse/jdwzBackz.jpg`" />
        <img
          class="back-img"
          v-if="data.courseType === '200'"
          :src="`${assetsUrl}imgs/course/teacherCourse/cjBackgsb.jpg`"
        />
        <img
          class="back-img"
          v-if="data.courseType === '201'"
          :src="`${assetsUrl}imgs/course/teacherCourse/cjBackzsb.jpg`"
        />
        <img
          class="back-img"
          v-if="data.courseType === '202'"
          :src="`${assetsUrl}imgs/course/teacherCourse/cjBackgsb.jpg`"
        />

        <img
          class="back-img"
          v-if="data.courseType === '7102'"
          :src="`${assetsUrl}imgs/course/teacherCourse/erjijianzaoshi.jpg`"
        />
        <img
          class="back-img"
          v-if="data.courseType === '7101'"
          :src="`${assetsUrl}imgs/course/teacherCourse/yijijianzaoshi.jpg`"
        />
        <div v-if="data.courseType === '123'" style="position:absolute; flex-wrap: wrap;" class="teacher-m" id="middle">
          <a
            v-for="item of list"
            :key="item.id"
            :style="{
              margin: list.length > 15 ? '.5rem .5rem' : '.5rem 1.5rem',
              width: list.length > 15 ? '20%' : '25%'
            }"
            @click="isIn(item)"
            :href="item.url"
            target="_blank"
          >
            <button class="able-in" style="background-color: white;" >
              {{ item.name }}
            </button>
          </a>
        </div>
        <div v-if="data.courseType === '1611' || data.courseType === '1612'" style="position:absolute; flex-wrap: wrap;" class="teacher-m" id="middle">
          <a
            v-for="item of list"
            :key="item.id"
            :style="{
              margin: list.length > 15 ? '.5rem .5rem' : '.5rem 1.5rem',
              width: list.length > 15 ? '20%' : '25%'
            }"
            @click="isIn(item)"
            :href="item.url"
            target="_blank"
          >
            <button class="able-in" style="background-color: white;" >
              {{ item.name }}
            </button>
          </a>
        </div>
        <div
          v-if="data.courseType === '200'"
          style="position:absolute; flex-wrap: wrap;top:44vh;"
          class="teacher-m"
          id="middle"
        >
          <a
            v-for="item of list"
            :key="item.id"
            :style="{
              margin: list.length > 15 ? '.5rem .5rem' : '.5rem 1.5rem',
              width: list.length > 15 ? '20%' : '25%'
            }"
            @click="isIn(item)"
            :href="item.url"
            target="_blank"
          >
            <button class="able-in" style="background-color: white;">
              {{ item.name }}
            </button>
          </a>
        </div>
        <div v-if="data.courseType === '201'" style="position:absolute; flex-wrap: wrap;" class="teacher-m" id="middle">
          <a
            v-for="item of list"
            :key="item.id"
            :style="{
              margin: list.length > 15 ? '.5rem .5rem' : '.5rem 1.5rem',
              width: list.length > 15 ? '20%' : '25%'
            }"
            @click="isIn(item)"
            :href="item.url"
            target="_blank"
          >
            <button class="able-in" style="background-color: white;">
              {{ item.name }}
            </button>
          </a>
        </div>
        <div
          v-if="data.courseType === '202'"
          style="position:absolute; flex-wrap: wrap;top:44vh;"
          class="teacher-m"
          id="middle"
        >
          <a
            v-for="item of list"
            :key="item.id"
            :style="{
              margin: list.length > 15 ? '.5rem .5rem' : '.5rem 1.5rem',
              width: list.length > 15 ? '20%' : '25%'
            }"
            @click="isIn(item)"
            :href="item.url"
            target="_blank"
          >
            <button class="able-in" style="background-color: white;">
              {{ item.name }}
            </button>
          </a>
        </div>
        <div
          v-if="data.courseType === '7102'"
          style="position:absolute; flex-wrap: wrap;top:44vh;"
          class="teacher-m"
          id="middle"
        >
          <a
            v-for="item of list"
            :key="item.id"
            :style="{
              margin: list.length > 15 ? '.5rem .5rem' : '.5rem 1.5rem',
              width: list.length > 15 ? '20%' : '25%'
            }"
            @click="isIn(item)"
            :href="item.url"
            target="_blank"
          >
            <button class="able-in" style="background-color: white;">
              {{ item.name }}
            </button>
          </a>
        </div>
        <div
          v-if="data.courseType === '7101'"
          style="position:absolute; flex-wrap: wrap;top:44vh;"
          class="teacher-m"
          id="middle"
        >
          <a
            v-for="item of list"
            :key="item.id"
            :style="{
              margin: list.length > 15 ? '.5rem .5rem' : '.5rem 1.5rem',
              width: list.length > 15 ? '20%' : '25%'
            }"
            @click="isIn(item)"
            :href="item.url"
            target="_blank"
          >
            <button class="able-in" style="background-color: white;">
              {{ item.name }}
            </button>
          </a>
        </div>
        <div style="position:absolute;" class="teacher-m">
          <a :href="data.classesUrls[0].url" target="_blank">
            <button v-if="data.courseType === '121'">进入</button>
            <button v-if="data.courseType === '122'">进入</button>
          </a>
        </div>
      </div>
      <div></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MockMacc',
  components: {},
  data() {
    return {
      assetsUrl: 'https://static.51lss.com/o2ostu/assets/',
      list: [],
      xueLiType: [
        'accKjzk',
        'accKjbk',
        'accGsglzk',
        'accGsglbk',
        'accHyyzk',
        'accHyybk',
        'accXzglzk',
        'accXzglbk',
        'accXlzk',
        'accQtzy'
      ],
      isXueli: false
    }
  },
  props: {
    courseType: {
      type: String,
      default: '',
      required: false
    },
    data: {
      type: Object,
      default: null,
      required: false
    },
  },
  created() {
    this.isXueli = this.xueLiType.includes(this.data.courseType)
     console.log('3221222222', this.xueLiType.includes(this.data.courseType))
    this.getList()
  },
  methods: {
    getList() {
      console.log(this.data.courseType)
      if (!this.data && !this.data.list) {
        return
      }
      this.data.classesUrls && this.data.classesUrls.forEach(item => {
        // eslint-disable-next-line no-unused-expressions
        item && this.list.push(item)
      })
    },

    isIn(item) {
      if (item.seq !== 0 || item.url == null) {
        // eslint-disable-next-line no-unused-expressions
        item.mess ? this.http.alertMsg('错误信息', item.mess) : ''
        return false
      }
      return true
    }
  }
}
</script>
<style scoped lang="less">
.outer-body {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto;
}

.inner-div {
  width: 51.2rem;
  height: 38.4rem;
  //background-image: url("https://o2o-demo.oss-cn-hangzhou.aliyuncs.com/o2ostu/assets/imgs/course/cpa/cpa-cost-back%20.jpg");
  background-image: url('#{$assetsUrl}imgs/course/cpa/cpa-cost-back%20.jpg');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  //background-image: url(assets/imgs/course/cpa-cost-back .jpg) no-repeat;
}
.title {
  margin-left: 4.4rem;
  margin-top: 2.6rem;
}
.title img {
  display: inline-block;
}
.logo-title {
  margin-left: 2rem;
  width: 25rem;
  margin-top: 0.8rem;
}
.main-div {
  width: 45.75rem;
  height: 23rem;
  background-color: white;
  border-radius: 0.6rem;
  margin-top: 3.4rem;
  margin-left: 2.7rem;
  box-shadow: 0 3px 13px rgba(0, 0, 0, 0.4);
}
.tiku-title {
  font-size: 1.5rem;
  color: #333;
  width: 100%;
  height: 5rem;
  line-height: 5rem;
  text-align: center;
}
.tiku-main {
  width: 100%;
  height: 17rem;
  display: flex;
  flex-flow: row wrap;
  padding-left: 5rem;
  padding-top: 1rem;
}
button {
  height: 3.3rem;
  width: 15.8rem;
  border: none;
  margin-right: 4rem;
  font-size: 1rem;
  border-radius: 1.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  line-height: 3.3rem;
  outline: none;
}
.able-in {
  color: #08528f;
  background-color: #d8edff;
  box-shadow: 0 2px 0 #b4deff;
}
.disable-in {
  color: #777;
  background-color: #d4dce2;
  box-shadow: 0 2px 0 #b3c0ca;
}
.able-in:hover {
  background-color: #98d172;
  //color: white;
  box-shadow: none;
}
a:hover {
  //color: white;
  box-shadow: none;
  text-decoration: none;
}
.disable-icon {
  font-size: 1.3rem;
  left: 0.5rem;
  float: left;
}

.able-in:active {
  box-shadow: 0 7px 5px rgba(0, 0, 0, 0.3) inset;
}

@media (min-height: 750px) and (max-height: 825px) {
  .inner-div,
  .macc-main {
    margin-top: 5rem;
    margin-bottom: 1rem;
  }
}
@media (min-height: 600px) and (max-height: 750px) {
  .inner-div,
  .macc-main {
    margin-top: 13rem;
    margin-bottom: 3rem;
  }
  .macc-main {
    margin-top: 10rem;
  }
}
@media (min-height: 600px) and (max-height: 680px) {
  .macc-main {
    margin-top: 15rem;
  }
}
@media screen and (max-height: 600px) {
  .inner-div,
  .macc-main {
    margin-top: 18rem;
  }
}
#middle {
  top: 32vh;
}
#middle a {
  width: 25%;
  button {
    width: 100%;
    font-size: 18px;
  }
}
.macc-main {
  width: 51.3rem;
  height: 38.5rem;
  background-color: white;
  border: 0.05rem solid #e3e3e3;
}
.macc-logo-title {
  height: 8.7rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.macc-logo-title > div {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.macc-logo-title img {
  width: 14rem;
}
.macc-content {
  width: 100%;
  height: 29.7rem;
  position: relative;
}
.macc-content > .back-img {
  width: 100%;
  height: 100%;
}
.middle-main {
  position: absolute;
  left: 0;
  right: 0;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: 0;
}
.middle-main > .back-img {
  width: auto;
  height: 98%;
}
.macc-content button {
  position: absolute;
  top: 6rem;
  bottom: 0;
  right: 0;
  left: 0;
  margin: auto;
  background-color: white;
  color: #208ca5;
  font-size: 1.1rem;
  box-shadow: 0 3px 0 #b1dbd9;
}
.macc-content > .mess-logo {
  width: 21.2rem;
  position: absolute;
  top: -10rem;
  bottom: 0;
  right: 0;
  left: 0;
  margin: auto;
}
.macc-content button:hover {
  background-color: #98d172;
  color: white;
  box-shadow: none;
}

.macc-content button:active {
  box-shadow: 0 7px 5px rgba(0, 0, 0, 0.3) inset;
}
.teacher-m {
  position: absolute;
  bottom: 132px;
  display: flex;
  justify-content: center;
  width: 100%;
}
.teacher-m button {
  margin: 0;
  background-color: white;
}
.btn-panel {
  position: absolute;
  flex-wrap: wrap;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
